import { render, staticRenderFns } from "./PageCitizenView.vue?vue&type=template&id=fa3b0586&"
import script from "./PageCitizenView.vue?vue&type=script&lang=js&"
export * from "./PageCitizenView.vue?vue&type=script&lang=js&"
import style0 from "./PageCitizenView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports